import { useRef, useEffect } from "react";

export const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; // Update the ref value *after* the render is committed to the DOM
  });
  return ref.current; // Return the value from the *previous* render
};
